import request from '@/utils/request'

// 登录方法
export function login(username, password,code,uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 企业微信获取登录方法
export function loginByWx(data) {
  return request({
    url: '/getWechatUserToken',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function weichatLogin(code) {
  return request({
    url: '/weichatLogin',
    headers: {
      isToken: false
    },
    method: 'post',
    data: {
      code: code
    }
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/wechat/getInfo',
    method: 'get'
  })
}



// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

/**
 *  获取PC端微信登录二维码地址
 * @returns {*}
 */
export function getWxappid() {
  return request({
    url: '/getWxappid',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

/**
 * 发送短信验证码
 *
 * @author ConFront_C_Eng
 * @date 2023-09-26 15:04:31
 */
export function sendSmsThird(query) {
  return request({
    url: '/sendSmsThird',
    method: 'get',
    params: query
  })
}

/**
 * 校验ticket
 * @author ConFront_C_Eng
 * @date 2023-09-27 16:20:45
 */
export function verifyTicket(query) {
  return request({
    url: '/verifyTicket',
    method: 'get',
    params: query
  })
}

/**
 * 登录并获取广联达跳转登录的 login_token
 *
 * @author ConFront_C_Eng
 * @date 2023-09-26 15:04:31
 */
export function getLoginToken(username, password, code, uuid) {
  const data = {
    mobile: username,
    code: password
  }
  return request({
    url: '/getLoginToken',
    headers: {
      isToken: false
    },
    method: 'get',
    params: data
  })
}

/**
 * 退出第三方登录
 *
 * @author ConFront_C_Eng
 * @date 2023-09-28 14:01:54
 */
export function removeThirdLogin(query) {
  return request({
    url: 'https://account.glodon.com/cas/serviceLogout',
    method: 'get',
    params: query
  })
}
